import nativeHookApi from '../native-hook-api'
import querystring from 'common/utils/querystring'

export enum MessageName {
  EXPIRED = 'expired',
  CONNECTED = 'connected',
  CANCELLED = 'cancelled',
  CLOSE = 'close',
  LOADED = 'loaded',
  CLIENT_ERROR = 'client-error',
  CLIENT_INTERFACE_EVENTS = 'client-interface-events',
  END = 'end',
  KEYBOARD_INPUT_RESPONSE = 'keyboard-input-response',
  LOAD = 'load',
  ORDER = 'order',
  PAYMENT_STATUS = 'payment-status',
  KP_AUTHORIZED = 'kp-authorized',
  CREATE_TOKEN = 'create-token',
  START_VCN_FLOW = 'start-vcn-flow', // to trigger virtual card flow,
  KP_LOADED = 'kp-loaded',
  REFRESH_USER_ACCESS_TOKEN = 'refresh-user-access-token',
  COMPLETE = 'complete'
}

export enum PaymentStatus {
  CANCEL = 'payment-cancelled',
  ERROR = 'payment-error',
  FAILURE = 'payment-failed',
  SUCCESS = 'payment-successful'
}

const shortDescriptions: Record<string, string> = {
  [MessageName.EXPIRED]: 'Token has expired',
  [MessageName.CONNECTED]: 'Connect consumer to token',
  [MessageName.CANCELLED]: 'Cancel token',
  [MessageName.CLOSE]: 'Close distribution module',
  // [MessageName.LOADED]: 'Done loading distribution module SDK',
  [MessageName.CLIENT_ERROR]: 'Unhandled error occurred',
  // [MessageName.CLIENT_INTERFACE_EVENTS]: 'User did something',
  [MessageName.END]: 'End distribution module',
  [MessageName.KEYBOARD_INPUT_RESPONSE]: 'Start typing in input field',
  [MessageName.LOAD]: 'Load distribution module',
  [MessageName.ORDER]: 'Complete tokenized payment',
  [MessageName.PAYMENT_STATUS]: 'Set payment status'
  // [MessageName.KP_AUTHORIZED]: '',
  // [MessageName.CREATE_TOKEN]: ''
  // [MessageName.START_VCN_FLOW]: '',
  // [MessageName.KP_LOADED]: '',
  // [MessageName.REFRESH_USER_ACCESS_TOKEN]: '',
}

function sendMessageToSDK(name: MessageName, data?, shortDescription?: string) {
  const parent = window.parent === window ? window.opener : window.parent
  const { view_id } = querystring()
  const event = JSON.stringify({
    name,
    data,
    short_description: shortDescription || shortDescriptions[name],
    view_id
  })

  if (nativeHookApi.isSupported()) {
    nativeHookApi.merchantEvent(event)
  }

  if (window.klarnaWebViewPostMessage) {
    window.klarnaWebViewPostMessage(event)
  } else if (parent && view_id) {
    parent.postMessage(event, '*')
  } else {
    if (process.env.NODE_ENV === 'test') return

    console.log({ name, data })
  }
}

export default sendMessageToSDK
